import { catchError, Observable, of, take, tap, timeout } from 'rxjs';

import { ServerTimeService } from '@tablesready/common-ui';
import { LoggerService } from '@tablesready/frontend-logger';
import { ServerDate } from '@tablesready/server-time';

/** Upper bound on the first server-time sample at boot; past it we boot unsynced. */
export const SERVER_TIME_BOOTSTRAP_TIMEOUT_MS = 10000;

/**
 * APP_INITIALIZER that seeds `ServerDate` with the first server-time offset.
 *
 * Must never reject or hang (a rejected APP_INITIALIZER aborts bootstrap and leaves a
 * blank page, see `authAppInitializerFactory`). Offline, or with the API down, no sample
 * arrives: after the timeout the app boots with the default offset of 0 and
 * `AuthenticatedInitializer` picks up the first successful sample later, since the
 * service keeps polling.
 */
export function serverTimeAppInitializerFactory(
  serverTimeService: ServerTimeService,
  logger: LoggerService,
): () => Observable<number | null> {
  return (): Observable<number | null> => serverTimeService.offset$.pipe(
    take(1),
    timeout({ first: SERVER_TIME_BOOTSTRAP_TIMEOUT_MS }),
    tap((offset) => {
      ServerDate.setOffset(offset);
    }),
    catchError((err: unknown) => {
      logger.error(err);

      return of(null);
    }),
  );
}
